'use strict';
// @flow

export default class BasicLayoutController {
  $state;
  $scope;
  $rootScope;
  canvas;
  layoutDefinition;

  /*@ngInject*/
  constructor($state, $scope, $rootScope, Canvas, LayoutDefinition) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.canvas = Canvas;
    this.layoutDefinition = LayoutDefinition;
  }

  $onInit() {
    let layouts = [];
    const _this = this;

    this.canvas.stageInitialized(function (stage) {
      _this.layoutDefinition.get(function (layoutDefinitions) {
        _this.$scope.layoutDefinitions = layoutDefinitions.layouts;
      });
    });
  }

  onLayoutSelected (id) {
    const _this = this;
    let layout = null;
    const layouts = this.$scope.layoutDefinitions;

    for (let i = 0; i < layouts.length; i++) {
      if (layouts[i].id === id) {
        layout = layouts[i];
        break;
      }
    }

    this.$rootScope.log('Using layout: ' + JSON.stringify(layout));

    // Set selected Layout to stage
    let newWidth = layout.dimensions.width;
    let newHeight = layout.dimensions.height;

    this.canvas.clearStage();
    this.canvas.setUseDivider(layout.useDivider);
    this.canvas.setUseDividerHorizontal(layout.useDividerHorizontal);
    this.canvas.setBounds(newWidth, newHeight, function () {
      let masks = layout.masks;
      let previewImages = [];

      for (let i = 0; i < masks.length; i++) {
        let mask = masks[i];
        let dimensions = {
          id: mask.id,
          photoId: mask.photoId,
          rotation: mask.rotation,
          w: mask.dimensions.width,
          h: mask.dimensions.height,
          x: mask.position.x,
          y: mask.position.y
        };

        previewImages.push(dimensions);
      }

      _this.canvas.setPreviewImages(previewImages, layout.name);
    });
  };
}



// WEBPACK FOOTER //
// ./client/app/configurator/basicLayout/basicLayout.controller.js